module.exports = __webpack_public_path__ + "static/caminhao taurus-1cfa803d7612d6e7ee3f39e5bc71af1d.jpg";